import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-expanding-text-area"
export default class AutoExpandingTextArea extends Controller<HTMLTextAreaElement> {
  private originalHeight: number = 0

  connect() {
    this.originalHeight = this.element.offsetHeight

    // On focus, adjust height in case content was changed programmatically
    this.element.addEventListener("focus", this.#onFocus)

    // On blur, reset height to initial
    this.element.addEventListener("blur", this.#onBlur)
  }

  disconnect() {
    this.element.removeEventListener("focus", this.#onFocus)
    this.element.removeEventListener("blur", this.#onBlur)
  }

  // Store bound handlers so removeEventListener works
  #onFocus = () => this.#expand()

  #onBlur = () => this.#shrink()

  #expand() {
    this.element.style.height = "auto" // Reset height to auto to get the correct scrollHeight
    this.element.style.height = `${this.element.scrollHeight + 2}px` // Set height to scrollHeight
  }

  #shrink() {
    this.element.style.height = `${this.originalHeight}px`
  }
}
